const ESTAMPAL_CATALOG_MOBILE_MAX = 749;

function estampalCatalogIsMobile() {
  return window.innerWidth <= ESTAMPAL_CATALOG_MOBILE_MAX;
}

/**
 * En móvil solo se muestran las primeras N tarjetas del filtro activo.
 *
 * Se hace en JS y no en CSS con :nth-child a propósito: el filtrado oculta
 * tarjetas sueltas repartidas por el DOM, así que "las 4 primeras" tiene que
 * contarse sobre las visibles del filtro, no sobre la posición en el HTML.
 * Con CSS, al filtrar por Fútbol saldrían las 4 primeras del catálogo entero.
 */
function applyEstampalMobileLimit(section, grid) {
  const limit = parseInt(section.dataset.mobileLimit, 10) || 0;
  const moreWrap = section.querySelector('[data-catalog-more]');
  const moreBtn = section.querySelector('[data-catalog-more-btn]');
  const cards = Array.from(grid.querySelectorAll('[data-category]'));

  const sinRecorte = !limit || !estampalCatalogIsMobile() || section.dataset.expanded === 'true';

  if (sinRecorte) {
    cards.forEach((card) => card.classList.remove('is-beyond-limit'));
    if (moreWrap) moreWrap.hidden = true;
    return;
  }

  const visibles = cards.filter((card) => !card.classList.contains('is-hidden'));
  visibles.forEach((card, i) => card.classList.toggle('is-beyond-limit', i >= limit));
  cards
    .filter((card) => card.classList.contains('is-hidden'))
    .forEach((card) => card.classList.remove('is-beyond-limit'));

  const restantes = Math.max(visibles.length - limit, 0);
  if (moreWrap && moreBtn) {
    moreWrap.hidden = restantes === 0;
    moreBtn.textContent =
      restantes === 1 ? 'Ver 1 producto más' : `Ver ${restantes} productos más`;
  }
}

function applyEstampalCatalogFilter(filterBar, grid, filter) {
  const button = filterBar.querySelector(`[data-filter="${filter}"]`);
  if (!button) return false;

  filterBar.querySelectorAll('[data-filter]').forEach((btn) => btn.classList.remove('is-active'));
  button.classList.add('is-active');

  grid.querySelectorAll('[data-category]').forEach((card) => {
    const show = filter === 'all' || card.dataset.category === filter;
    card.classList.toggle('is-hidden', !show);
  });

  // al cambiar de pestaña se vuelve a plegar: si no, un filtro con 5 productos
  // heredaría el "ver más" que abriste en otro
  const section = filterBar.closest('.estampal-catalog');
  if (section) {
    section.dataset.expanded = 'false';
    applyEstampalMobileLimit(section, grid);
  }
  return true;
}

function initEstampalCatalogFilters() {
  document.querySelectorAll('[data-catalog-filters]').forEach((filterBar) => {
    const section = filterBar.closest('.estampal-catalog');
    const grid = section && section.querySelector('[data-catalog-grid]');
    if (!grid) return;

    filterBar.addEventListener('click', (event) => {
      const button = event.target.closest('[data-filter]');
      if (!button) return;
      applyEstampalCatalogFilter(filterBar, grid, button.dataset.filter);
    });

    const moreBtn = section.querySelector('[data-catalog-more-btn]');
    if (moreBtn) {
      moreBtn.addEventListener('click', () => {
        section.dataset.expanded = 'true';
        applyEstampalMobileLimit(section, grid);
      });
    }

    // Footer links like #ropa / #accesorios / #oficina / #productos pre-filter and scroll here.
    const applyFromHash = () => {
      const hash = window.location.hash.replace('#', '');
      if (!hash) return;
      if (hash === 'productos') {
        section.scrollIntoView({ behavior: 'smooth' });
        return;
      }
      if (applyEstampalCatalogFilter(filterBar, grid, hash)) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    };

    window.addEventListener('hashchange', applyFromHash);

    // al girar el móvil o pasar a escritorio hay que recalcular el recorte
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => applyEstampalMobileLimit(section, grid), 150);
    });

    applyEstampalMobileLimit(section, grid);
    applyFromHash();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEstampalCatalogFilters);
} else {
  initEstampalCatalogFilters();
}
